module.exports = __webpack_public_path__ + "img/exam_jan_2025_vk7r1lzp.e94ab544.jpg";